import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import createShowIf from 'v2/components/Shared/createShowIf';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';

import { commissionTypes, ECommissionType } from '../../classes/Product';

import type { Recruiter as RecruiterClass } from '../../classes/Affiliates';

interface IProps extends IForm<RecruiterClass> {}

const Recruiter = ({ values, setFocus }: IProps) => {
  const ShowIfRecruiter = createShowIf<RecruiterClass>();

  const maxSalesOptions = [
    { label: 'Indeterminado', value: 0 },
    ...[10, 20, 30, 40, 50, 100, 200, 500, 1000].map((value) => ({
      label: value.toString(),
      value,
    })),
  ];

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field onFocus={setFocus} label='Comissão de recrutamento' id='recruit' name='recruit' component={SwitchFormField} />
        </Grid>
        <ShowIfRecruiter value={values} compare={{ eq: { recruit: true } }}>
          <Grid item xs={12}>
            <Field
              label='Tipo de comissão de recrutamento'
              id='recruit_commission_type'
              name='recruit_commission_type'
              options={commissionTypes}
              component={SelectFormField}
              disabled={values.recruit_commission_type === ECommissionType.PERCENTAGE}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              label='Valor da comissão'
              id='recruit_commission_value'
              mask={values.recruit_commission_type === ECommissionType.PERCENTAGE ? 'percent' : 'money'}
              name='recruit_commission_value'
              component={TextFormField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field label='Máximo de Vendas' id='recruit_max_sales' name='recruit_max_sales' options={maxSalesOptions} component={SelectFormField} />
          </Grid>
        </ShowIfRecruiter>
      </Grid>
    </Fragment>
  );
};

export default Recruiter;
